var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isPrint)?_c('vs-button',{staticClass:"mb-4",staticStyle:{"float":"right"},attrs:{"color":"secondary","type":"border"},on:{"click":_vm.handlePrint}},[_vm._v("인쇄")]):_vm._e(),_c('print',{attrs:{"id":"print-report","board":_vm.board,"form":_vm.form}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }